import React from "react"

const Checkmark = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 49">
      <polyline
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="5"
        points="3 26.291 21.491 45 63 3"
      />
    </svg>
  )
}

export default Checkmark
